@if (true) {
<div *ifStandalone
     class="w-12"
     style="height: 36px"></div>
<div class="w-12 wrap left">
    <div class="flex flex-column-reverse-m flex-column-reverse-s">
        <h1 class="h2 w-3-x w-3-l p-t-4-m p-t-4-s"
            *iCms="'title' of component"></h1>
        <icms-outlet [components]=" component.components"
                     [allowOnly]="['quick-links']"
                     [name]=" 'Quick Links / middle section'">
        </icms-outlet>
    </div>
    <read-more class="p1 w-8 w-12-s p-t-4"
               [text]="component.description"
               [limit]="[100,150,200,200][client.sizeId]"
               [readLess]="true"
               [inline]="false">
    </read-more>
</div>
}
